<template>
  <div class="layer_section-container">
    <div class="layer-header">
      <h1 class="header-title">
        ABC 마이팩 랩 방문 예약
      </h1>
    </div>
    <div class="layer-content">
      <reservation-link :on-button="false" />

      <div class="layer_tbl_content">
        <h3>예약 안내사항</h3>
        <table>
          <colgroup>
            <col width="35%">
            <col width="*">
          </colgroup>
          <tbody>
            <tr>
              <th>예약시간</th>
              <td>
                ABC 오픈 시간 동안 15분 단위로 예약<br>
                * 월-금 : 10시~20시<br>
                * 토 : 10시~18시 <br>
                * 한 번 방문에 5팩 한꺼번에 주문 가능
              </td>
            </tr>
            <tr>
              <th>예약가능 횟수</th>
              <td>월 1회/조</td>
            </tr>
            <tr>
              <th>예약취소</th>
              <td>예약 <strong>예정일 전날 까지</strong> 가능하며, 취소 패널티는 없으나, No show 패널티 있음(해당 일로부터 30일간 예약 불가)</td>
            </tr>
            <tr>
              <th>예약오픈</th>
              <td>
                전 달 15일 오전 9시에 다음 달 예약 오픈<br>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
      </div>
    <div class="align-box size-auto">
      <button
        type="button"
        class="btn-modal_close"
        @click="onDispose"
      >
        닫기
      </button>
    </div>
  </div>
</template>

<script>
import ReservationLink from '@/components/ReservationLink.vue';

export default {
  name: 'PopupReservation',
  components: {
    ReservationLink,
  },
  methods: {
    onDispose() {
      this.$emit('dispose', 'get out!');
    },
  },
};
</script>

<style>

</style>
